import React, {FunctionComponent} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconProp} from "@fortawesome/fontawesome-svg-core";

import './GettingToWizard.css';

interface IIconSeparator{
    icon:IconProp;
}

const IconSeparator:FunctionComponent<IIconSeparator> = ({icon}) => {
    return <FontAwesomeIcon className="getting-to-wizard__icon-separator" icon={icon} size="2x"/>
};

export default IconSeparator;
